export default __webpack_public_path__ + "static/media/ic_stats.f0a18011.svg";